import React, { useEffect, useState } from 'react';
import { Grid, Icon, Dropdown, Loader, Label } from 'semantic-ui-react';
import { HttpClient } from '../../api/httpClient';
import { DECLARATION_OPTIONS } from '../util/constants';

function AdditionalDeclarations({
  disabled,
  formDisabled,
  invoiceId,
  merchandiseId,
  shipmentId,
  declarations,
  invoiceItemIndex,
  lineItemIndex,
  addDeclarations,
  deleteDeclarations,
  disabledState
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedDeclarations, setSelectedDeclarations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSelectedDeclarations(declarations || []);
  }, []);

  const getDeclarationByValue = (value) =>
    DECLARATION_OPTIONS.find((opt) => opt.value === value) || {};

  const buildPayload = (value, isDelete = false) => {
    const { information, typeCode } = getDeclarationByValue(value);
    return {
      eventType: 'SAVE_ENTRY_SUMMARY_DUTIES',
      eventTime: Date.now(),
      eventMessage: {
        descriptionOfMerchandise: {
          entrySummaryInvoices: [
            {
              invoiceId,
              merchandiseLineItems: [
                {
                  merchandiseId,
                  importerAdditionalDeclarationDetails: {
                    importerAdditionalDeclarationDetail: [
                      {
                        information: isDelete ? '_BLANK_' : information,
                        typeCode,
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
        shipmentId,
      },
    };
  };

  const handleSelect = async (e, data) => {
    setLoading(true);
    try {
      const payload = buildPayload(data.value);
      await HttpClient.custom({ data: payload });
      setSelectedDeclarations([...selectedDeclarations, data.value]);
      addDeclarations({invoiceItemIndex, lineItemIndex, newDeclaration: DECLARATION_OPTIONS.find(opt => opt.value === data.value)});
      setShowDropdown(false);
    } catch (error) {
      console.error('Failed to add declaration', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (value) => {
    setLoading(true);
    try {
      const payload = buildPayload(value, true);
      await HttpClient.custom({ data: payload });
      setSelectedDeclarations(selectedDeclarations.filter((d) => d !== value));
      deleteDeclarations({invoiceItemIndex, lineItemIndex, typeCode: value})
    } catch (error) {
      console.error('Failed to delete declaration', error);
    } finally {
      setLoading(false);
    }
  };

  const canAddMore = selectedDeclarations.length < 3;

  return (
    <Grid.Row style={{ marginTop: '10px' }}>
      <Grid.Column style={{ width: '100%' }}>
        <a
          style={{
            color: canAddMore && !disabled ? '#1a69a4' : '#aaa',
            cursor: disabled ? 'not-allowed' : 'pointer',
            marginLeft: '5px',
            display: 'inline-block',
          }}
          onClick={
            !disabledState && !disabled && canAddMore && !showDropdown
              ? () => setShowDropdown(true)
              : undefined
          }
        >
          {canAddMore && !selectedDeclarations?.length && (
            <Icon name='add circle' disabled={formDisabled} />
          )}
          Add Additional Declaration(s)
        </a>

        <div
          style={{ marginLeft: '3%', display: 'flex', alignItems: 'center' }}
        >
          {loading ? (
            <Loader active inline size='small' />
          ) : (
            <>
              {selectedDeclarations.map((declaration, index) => (
                <Label
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '2px',
                    marginLeft: '14px',
                  }}
                >
                  {getDeclarationByValue(declaration).text || declaration}
                  {!disabledState && <Icon
                    name='delete'
                    onClick={() => handleDelete(declaration)}
                  />}
                </Label>
              ))}
              {!showDropdown && canAddMore && selectedDeclarations?.length ? (
                <a style={{ cursor: 'pointer', marginLeft: '5px' }}>
                  <Icon
                    name='add circle'
                    disabled={formDisabled}
                    onClick={
                      !disabled && canAddMore && !showDropdown
                        ? () => setShowDropdown(true)
                        : undefined
                    }
                  />
                </a>
              ) : null}
              {showDropdown && canAddMore && (
                <span style={{ marginLeft: '3%' }}>
                  <Dropdown
                    style={{ border: 'none' }}
                    inline
                    placeholder='Select Declaration'
                    selection
                    options={DECLARATION_OPTIONS.filter(
                      (opt) => !selectedDeclarations.includes(opt.value)
                    )}
                    onChange={handleSelect}
                    disabled={formDisabled}
                  />
                  <Icon
                    name='delete'
                    color='red'
                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                    onClick={() => setShowDropdown(false)}
                  />
                </span>
              )}
            </>
          )}
        </div>
      </Grid.Column>
    </Grid.Row>
  );
}

export default AdditionalDeclarations;
